import React from 'react';


function Slider({label, min, max, value, setValue, prefixValueUnit, sufixValueUnit}) {

  const handleChange = (event) => {
    setValue(event.target.value);
  };


  return (
    <div>
        <div className='label-cont'>
         <label>{label}</label><span>{prefixValueUnit}{parseInt(value).toLocaleString()}{sufixValueUnit}</span>
        </div>
        <input
            type="range"
            min={min}
            max={max}
            value={value}
            onChange={handleChange}
            style={{backgroundSize: `${(value * 100) / max}% 100%`}}
        />
    </div>
  );
}

export default Slider;